import { render, staticRenderFns } from "./SpeakerForm.vue?vue&type=template&id=6a04efaa&"
import script from "./SpeakerForm.vue?vue&type=script&lang=js&"
export * from "./SpeakerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports